// extracted by mini-css-extract-plugin
export var container = "_rf-0";
export var table = "_rf-2";
export var tableWrapper = "_rf-1";